import React, { Component } from 'react';
import { Modal, InputNumber, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import './index.less';


class Update extends Component {
    state = {
        visible: false,
        loading: false,
        totalValue: 100,
        list: [],
    }

    show = recordData => {
        this.setState({
            visible: true,
            list: recordData
        });
    }

    hide = () => {
        const { siteStartType } = this.props;
        this.setState({
            visible: false,
            loading: false,
            totalValue: 100,
            list: [],
        },() => {
            this.props.loadData(siteStartType);
        });
    }

    submit = () => {
        const { list, totalValue } = this.state;
        const { siteStartType } = this.props;
        if (totalValue != 100) {
            return message.warning('请确保各工作内容的分配系数之和=100%！');
        }
        let obj = {};
        list.map(el => {
            const {workContentCode, workContentRate} = el;
            obj[`datas[${workContentCode}]`] = workContentRate;
        })
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.saveClinicalSiteStartFeeRate,
            data: {
                siteStartType,
                ...obj,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key, index) => {
        const { list } = this.state;
        list[index][key] = value;
        let num = 0;
        list.map(el => {
            num = num + (el.workContentRate || 0);
        })
        this.setState({ 
            list,
            totalValue: Number(num.toFixed(2)),
        });
    }

    render() {
        const { visible, loading, totalValue, list } = this.state;
        return (
            <Modal
                title={`修改工作内容费用占比`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
                bodyStyle={{ maxHeight: 550 }}
            >
                <div className='modal_content'>
                    <div className='content_item' style={{ marginBottom: 25 }}>
                        <div className='item_left' style={{ paddingLeft: '20%', fontWeight: 900 }}>工作内容</div>
                        <div className='item_right' style={{ fontWeight: 900 }}>工作内容-费用占比（%）</div>
                    </div>
                    {
                        list.map((el, index) => <div className='content_item'>
                            <div className='item_left'>{el.workContent}</div>
                            <div className='item_right'>
                                <InputNumber 
                                    style={{ width: 160}}
                                    step={0.01} 
                                    value={el.workContentRate} 
                                    min={0} 
                                    precision={2} 
                                    onChange={value => this.handleChange(value, 'workContentRate', index)} 
                                />
                                <span style={{ marginLeft: 10 }}>%</span>
                            </div>
                        </div>)
                    }
                    <div className='content_item'>
                        <div className='item_left' style={{ paddingLeft: '22%' }}>合计</div>
                        <div className='item_right'>
                            <span style={{ marginLeft: 5 }}>{totalValue}%</span>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/businessOffer/siteStartServiceFeePercent/Update.js